import { render, staticRenderFns } from "./application-franchise.vue?vue&type=template&id=6897782f&scoped=true"
import script from "./application-franchise.vue?vue&type=script&lang=ts"
export * from "./application-franchise.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6897782f",
  null
  
)

export default component.exports